import Container from '@/components/Container';

const CourseSkeleton = () => {
  return (
    <Container className="min-h-40">
      <div className="col-span-12 lg:col-start-3 lg:col-end-11">
        <div className="mb-8 mt-8 h-8 w-[150px] animate-pulse rounded-md bg-gray-300"></div>

        <div className="my-8 h-96 animate-pulse rounded-2xl bg-gray-300"></div>

        <div className="mb-2 h-8 w-1/4 animate-pulse rounded-md bg-gray-300"></div>
        <div className="mb-8 h-8 w-1/2 animate-pulse rounded-md bg-gray-300"></div>

        <div className="mb-8 h-4 animate-pulse rounded-md bg-gray-300"></div>
        <div className="mb-8 h-8 w-3/4 animate-pulse rounded-md bg-gray-300"></div>
        <div className="mb-8 h-4 w-2/4 animate-pulse rounded-md bg-gray-300"></div>

        <div className="mb-8 h-6 animate-pulse rounded-md bg-gray-300"></div>

        <div className="mb-8 h-4 animate-pulse rounded-md bg-gray-300"></div>
      </div>
    </Container>
  );
};

export default CourseSkeleton;
